import {Container} from "inversify";
import IGame from "./IGame";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import GameSlots from "./slot/GameSlots";
import IGameCore from "./IGameCore";
import IBootConfig from "../boot/IBootConfig";
import GameSlotsCore from "./GameSlotsCore";

export function defineSlotGame(container: Container, config?: IBootConfig) {

    container.bind<IGameCore>(SERVICE_IDENTIFIER.GameCore).to((config && config.GameCore) || GameSlotsCore).inSingletonScope();
    container.bind<IGame>(SERVICE_IDENTIFIER.Game).to(GameSlots).inSingletonScope();
}